var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentAdvice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 18.8398H12.2891V20.8711H16.5547V18.8398Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32725 15.3754C8.85072 14.9555 8.26719 14.6514 7.70286 14.3573L7.67548 14.343C6.71729 13.8435 6.39844 13.5817 6.39844 13.0159C6.39844 12.6355 6.78336 12.2891 7.20601 12.2891C7.62161 12.2891 7.97266 12.6146 7.97266 13H10.0039C10.0039 11.822 9.24198 10.8152 8.17578 10.4279V8.78516H6.14453V10.4663C5.11362 10.8843 4.36719 11.8833 4.36719 13.016C4.36719 14.9092 5.85041 15.6824 6.73654 16.1443L6.76406 16.1586C7.79274 16.6947 8.27734 16.9956 8.27734 17.4366C8.27734 18.0145 7.77669 18.5215 7.20601 18.5215C6.64056 18.5215 6.14453 18.009 6.14453 17.4248H4.11328C4.11328 18.7643 4.99754 19.9389 6.19531 20.3734V21.9375H8.22656V20.3758C8.65932 20.2211 9.05821 19.9681 9.39616 19.6271C9.98456 19.0334 10.3086 18.2555 10.3086 17.4366C10.3086 16.6425 9.97841 15.9491 9.32725 15.3754Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 14.7773H12.2891V16.8086H16.5547V14.7773Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.394 0H3.04688C1.36683 0 0 1.36683 0 3.04688V22.9531C0 24.6332 1.36683 26 3.04688 26H17.5647C19.2447 26 20.6116 24.6332 20.6116 22.9531V7.25446L13.394 0ZM13.9592 3.4481L17.1527 6.65803H14.9748C14.4148 6.65803 13.9592 6.20242 13.9592 5.64241V3.4481ZM18.5803 22.9531C18.5802 23.5131 18.1247 23.9688 17.5646 23.9688H3.04688C2.48686 23.9688 2.03125 23.5131 2.03125 22.9531V3.04688C2.03125 2.48686 2.48686 2.03125 3.04688 2.03125H11.928V5.64236C11.928 7.3224 13.2948 8.68923 14.9748 8.68923H18.5803V22.9531Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 10.7148H12.2891V12.7461H16.5547V10.7148Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAdvice);
export default __webpack_public_path__ + "static/media/paymentAdvice.83ad1067766f4032b0452e8997b48d78.svg";
export { ForwardRef as ReactComponent };